import { int } from "@goodgamestudios/math-utilities";

import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";

import { Poker2UserEvent } from "../../../event/Poker2UserEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Command } from "../Poker2Command";

export class SOECommand extends Poker2Command {
    protected get cmdId(): string {
        return "soe";
    }

    public executeCommand(error: number, params: any[]): boolean {
        switch (error) {
            case 0:
                params.shift();
                var percentGold: number = params.shift();
                var percentChips: number = params.shift();
                var daysleft: number = int(params.shift());
                var isRegBonus: boolean = int(params.shift()) == 1;
                var higherSpecialOffer: number = int(percentGold > percentChips ? percentGold : percentChips);
                Poker2Model.sessionData.highestSpecialOffer = higherSpecialOffer;
                Poker2Model.sessionData.specialOffer_Cash = percentChips;
                Poker2Model.sessionData.specialOffer_Gold = percentGold;
                Poker2Model.sessionData.specialOffer_Delay = daysleft;
                Poker2Model.sessionData.specialOffer_RegisterBonus = isRegBonus;
                Poker2Model.sessionData.activeSpecialOffer = true;

                this.controller.dispatchEvent(new Poker2UserEvent("paymentbouns"));
                return true;
        }
        return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
